export const loadImg = (url: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(url);
        image.onerror = () => reject(new Error(`Failed to load ${url} image`));

        image.src = url;
    });
};
